import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingSecurity4 = props => (
    <section id="outsourcing-security-section4" className="my pt-5">
        <div className='white-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingSecurity:section-4.title')}</h2>
            <p className='m-0'>
                <Trans i18nKey="services:outsourcingSecurity:section-4.text"
                    components={{
                        br: <br />,
                        outsourcingRisks: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_risks.path')} className="link" />
                    }}
                />
            </p>
        </Container>
    </section>
);

export default OutsourcingSecurity4;
